import { ChangeEvent } from 'react';

import { ProgramProgress, SubPhase, SubPhaseContent } from '@xq/domain';

import {
  StyledAccordionsContainer,
  StyleTabContainer,
} from './TabContent.styles';
import { Accordions } from '../Accordions/Accordions';
import { PhaseContentFooter } from '../PhaseContentFooter/PhaseContentFooter';
import { usePhase, useSubPhase } from '../../context';
import { useSubPhasesRef } from '../../hooks';
import { TeacherLabel } from '../Teacher/TeacherLabel';

type PhaseContentProps = {
  programProgress?: ProgramProgress;
  handleSubPhaseCheck?: (
    event: ChangeEvent<HTMLInputElement>,
    subPhase: SubPhase,
    subPhaseContent?: SubPhaseContent
  ) => void;
  panelIndex: number;
  onScroll?: () => void;
};

export const PhaseContentPanel = ({
  programProgress,
  handleSubPhaseCheck,
  panelIndex,
  onScroll,
}: PhaseContentProps) => {
  const { inResources } = usePhase();
  const { phase } = useSubPhase();
  const { assignSubPhaseRef } = useSubPhasesRef(panelIndex.toString());

  return (
    <>
      {!!phase.subPhaseValues?.length && (
        <StyleTabContainer>
          <StyledAccordionsContainer onScroll={onScroll}>
            <Accordions
              assignSubPhaseRef={assignSubPhaseRef}
              programProgress={programProgress}
              handleSubPhaseCheck={handleSubPhaseCheck}
              rightAccordionHeader={inResources ? <TeacherLabel /> : undefined}
            />
          </StyledAccordionsContainer>

          <PhaseContentFooter />
        </StyleTabContainer>
      )}
    </>
  );
};
